import type { FaireProductEntity } from "../../entity_types/product";

export const p_t7czy2wtup: FaireProductEntity = {
  token: "p_t7czy2wtup",
  type: "product",
  name: "The Full Armor of God: Interactive Brick Building Set (1080+ pcs)",
  brandToken: "b_95gwwb5hnm",
  brandName: "Little Nehemiah",
  imageUrl:
    "https://cdn.faire.com/fastly/dc043d78bdb7900886fae6a118ce8a0f551fc446e43d0c28835e6401b8e83228.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb9b9dac8f36df70eca8d514fc7edc26105ec83bc59f079a957dd7cb10b903c9.jpeg",
    "https://cdn.faire.com/fastly/d76e236cecaa20a4125ed1b9d4320eedd8e3db3b0029ff8e0810d3f6b4d4f1bb.jpeg",
    "https://cdn.faire.com/fastly/ce83cc80c66f7da9af5d0d3c6ba5dd3b037ee9178f039fbaa869d3b72df1a8db.jpeg",
    "https://cdn.faire.com/fastly/5f119a25c6a8c0298d3f9379681878597d052ad431212ef73cc24ba45a082121.jpeg",
    "https://cdn.faire.com/fastly/687e366bc0980303bed588c226c06da59ed38c1327b733548ed7daa6ef07d6ea.jpeg",
    "https://cdn.faire.com/fastly/a4ac65397f581eb0dfeeaac4bbf58e9fb32305275224752c9fc98e14154d7e88.jpeg",
    "https://cdn.faire.com/fastly/7dc18cadb79453870b613b6324d41cacf6e64df69c35ea4c3490687a5e63d2fc.jpeg",
    "https://cdn.faire.com/fastly/bcbed0ff821f30cf5b5b26641785d6bf4d097e10f3c767980db7a59b3a209923.jpeg",
    "https://cdn.faire.com/fastly/e501323678b1be832a6f502d4d0acb87af4b81589a0bada859f4da8b917e2fa0.jpeg",
  ],
  priceDollars: 58.2,
  description:
    "A joyful, Bible-based brick building experience inspired by the Full Armor of God (Ephesians 6), created as a meaningful gift for families to build faith together.\n",
  tags: [],
  msrpDollars: 97,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:10.053Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
